import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { LoadingSpinner } from "@/shared/components/ui/LoadingSpinner";

interface ProtectedRouteProps {
  children: React.ReactNode;
  returnTo?: string;
}

export function ProtectedRoute({ children, returnTo }: ProtectedRouteProps) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingSpinner fullScreen />;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: returnTo ?? `${location.pathname}${location.search}${location.hash}` }} replace />;
  }

  return <>{children}</>;
}
